<template>
  <div id="container">
    <!-------------- 发货信息 -------------->
    <shipping-information ref="shipmentInforRefs" @shipmentInfor="shipmentInfor"></shipping-information>
    <!-------------- 物流信息 -------------->
    <logistics-information
      :contractFrom="contractFrom"
      @purchaseDeliverLogisticVo="purchaseDeliverLogisticVo"
    ></logistics-information>
    <!-------------- 发货清单列表 -------------->
    <delivery-list ref="deliveryListRefs" @deliveryList="deliveryList"></delivery-list>
    <div style="margin-top:20px;">
      <el-button @click="onInformationSubmit" type="primary">信息提交</el-button>
    </div>
    <!-------------- 二次确认 -------------->
    <open-or-close-dialog
      ref="openOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close-dialog>
  </div>
</template>
<script>
import {
  queryShipmentPage,
  addBySupplierContract,
  queryShipmentMessageStraight
} from '@/api/purchase/purchasePlanList'
import shippingInformation from './shippingInformation' // 发货信息
import deliveryList from './deliveryList' // 产品清单
import logisticsInformation from './logisticsInformation' // 物流信息
import openOrClose from '@/components/OpenOrClose/index' // 二次确认
export default {
  components: {
    'open-or-close-dialog': openOrClose,
    'delivery-list': deliveryList,
    'logistics-information': logisticsInformation,
    'shipping-information': shippingInformation
  },
  data() {
    return {
      contractFrom: '',
      params: {}, // 查询
      sendParams: {},
      content: '',
      title: '',
      uploadData: {
        shipmentMessageVo: {},
        purchaseDeliverLogisticVo: {},
        purchaseContractShipmentVoList: []
      } // 上传数据
    }
  },
  mounted() {
    if (this.$route.query.sendType === '入库') {
      this.getList()
    } else {
      this.getListStraight()
    }
  },

  methods: {
    shipmentInfor(val) {
      this.uploadData.shipmentMessageVo = val
      // console.log(val, '我是发货信息')
    },
    purchaseDeliverLogisticVo(val) {
      // console.log(val, '我是物流信息')
      this.uploadData.purchaseDeliverLogisticVo = val
    },
    deliveryList(val) {
      // console.log(val, '我是清单信息')
      this.uploadData.purchaseContractShipmentVoList = val
    },
    getList() {
      const params = {
        criteriaVoList: [this.params],
        queryPageName: ''
      }
      queryShipmentPage(this.$route.query.pcbId, params)
        .then(res => {
          if (res.data.code === 200) {
            this.$refs.shipmentInforRefs.onInitial(res.data.obj.shipmentMessageVo)
            this.contractFrom = res.data.obj.shipmentMessageVo.contractFrom
            const params = res.data.obj.purchaseContractShipmentVoList
            this.$refs.deliveryListRefs.onInitial(params)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getListStraight() {
      const params = {
        criteriaVoList: [this.params],
        queryPageName: ''
      }
      queryShipmentMessageStraight(this.$route.query.pcbId, params)
        .then(res => {
          if (res.data.code === 200) {
            this.$refs.shipmentInforRefs.onInitial(res.data.obj.shipmentMessageStraightVo)
            const params = res.data.obj.purchaseContractShipmentVoList
            this.$refs.deliveryListRefs.onInitial(params)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 发起发货
    onInformationSubmit() {
      if (this.$route.query.sendType === '入库') {
        if (this.uploadData.purchaseDeliverLogisticVo.logisticType !== undefined) {
          const dataArray = Object.values(this.uploadData.purchaseDeliverLogisticVo)
          if (
            this.uploadData.shipmentMessageVo.storageName === undefined ||
            this.uploadData.shipmentMessageVo.storageName === null
          ) {
            this.$message.error('请填写完整发货信息！')
          } else if (dataArray.some(ele => ele === undefined)) {
            this.$message.error('请填写完整发货信息！')
          } else if (this.uploadData.purchaseContractShipmentVoList.length === 0) {
            this.$message.error('请填写完整发货信息！')
          } else {
            this.title = '提交确认'
            this.content = '发货信息提交后无法撤回，是否确认提交？'
            this.$refs.openOrCloseRefs.onInitial()
          }
        } else {
          this.$message.error('请填写完整发货信息！')
        }
      } else if (this.$route.query.sendType === '直发') {
        let isTrue = false
        if (this.uploadData.purchaseDeliverLogisticVo.logisticType !== undefined) {
          const dataArray = Object.values(this.uploadData.purchaseDeliverLogisticVo)
          dataArray.some(element => {
            if (element === undefined) {
              this.$message.error('请填写完整发货信息！')
              isTrue = true
              return false
            }
          })
          if (!isTrue) {
            if (this.uploadData.purchaseContractShipmentVoList.length === 0) {
              this.$message.error('请填写完整发货信息！')
            } else {
              this.title = '提交确认'
              this.content = '发货信息提交后无法撤回，是否确认提交？'
              this.$refs.openOrCloseRefs.onInitial()
            }
          }
        } else {
          this.$message.error('请填写完整发货信息！')
        }
      }
    },
    // 确认发起发货
    onUpdataState() {
      const params = JSON.parse(JSON.stringify(this.uploadData))
      params.pcbId = this.$route.query.pcbId
      addBySupplierContract(params)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success('已提交发货信息！')
            this.$router.push({
              name: 'contractDetails',
              query: {
                pcbId: this.$route.query.pcbId,
                type: this.$route.query.type
              }
            })
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
}
</script>
<style lang="scss" scoped></style>
